const moduleName = 'measurementChartGroup';

import {components, reducers} from 'linksoft';

import measurementChartGroupContainer from './chart-group';
//import reducer from './reducer';

components.add('measurement-chart-group', measurementChartGroupContainer);

//reducers.add(moduleName, reducer);

export default {
    name: moduleName,
    containers: [measurementChartGroupContainer],
};


// WEBPACK FOOTER //
// ./App/components/modules/measurement-chart-group/index.js